import React from 'react';
import { Container, Row, Col, Form, Button, FormCheck } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

const ReportForm = () => {
  return (
    <Container className="mt-4" style={{ maxWidth: '600px', marginLeft: '0px' }}>
     <h2 className="text-left mb-4 text-dark">Parameters</h2>
      <Form className="p-4 border rounded" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
        {/* Group By Selection */}
        <Form.Group as={Row} controlId="group_by" className="mb-4">
          <Form.Label column sm="4">Group By</Form.Label>
          <Col sm="8">
            <Form.Select name="group_by" id="group_by">
              <option value="technician">Technician</option>
              <option value="department">Department</option>
            </Form.Select>
            <FormCheck 
              type="checkbox" 
              name="new_page" 
              id="pay_per_task_new_page" 
              value="1"
              label="New Page Per Group"
              style={{ marginTop: "10px" }}
            />
          </Col>
        </Form.Group>

        {/* Start Date Input */}
        <Form.Group as={Row} controlId="pay-per-task-start-date" className="mb-4">
          <Form.Label column sm="4">Start Date <span className="text-danger">*</span></Form.Label>
          <Col sm="8">
            <Form.Control 
              type="date" 
              name="start_date" 
              required 
              defaultValue="2024-09-01" 
            />
          </Col>
        </Form.Group>

        {/* End Date Input */}
        <Form.Group as={Row} controlId="pay-per-task-end-date" className="mb-4">
          <Form.Label column sm="4">End Date <span className="text-danger">*</span></Form.Label>
          <Col sm="8">
            <Form.Control 
              type="date" 
              name="end_date" 
              required 
              defaultValue="2024-09-30" 
            />
          </Col>
        </Form.Group>

        {/* Accounts Selection */}
        <Form.Group as={Row} controlId="pay_per_task_practice" className="mb-4">
          <Form.Label column sm="4">Accounts</Form.Label>
          <Col sm="8">
            <Form.Select 
              name="practice" 
              id="pay_per_task_practice"
            >
              <option value="0">All</option>
              <option value="144545">2ingis s.a.</option>
              <option value="71159">ALL SAINTS DENTAL</option>
              <option value="88036">Wood End Dental Surgery</option>
            </Form.Select>
            <FormCheck 
              type="checkbox" 
              name="include_closed" 
              value="1" 
              label="Include Closed" 
              className="mt-2"
            />
          </Col>
        </Form.Group>

        {/* Account Tags */}
        <Form.Group as={Row} controlId="report_pay_per_task_account_tags" className="mb-4">
          <Form.Label column sm="4">Account Tags</Form.Label>
          <Col sm="8">
            <Form.Select 
              name="tags"
            >
              <option value="">No filter</option>
              <option value="a-practices">a-practices</option>
              <option value="bhandal">bhandal</option>
              <option value="coventry-dental">coventry-dental</option>
              <option value="dental-beauty">dental-beauty</option>
              <option value="murray-dental-">murray-dental-</option>
              <option value="swissmeda">swissmeda</option>
            </Form.Select>
          </Col>
        </Form.Group>

        {/* Format Selection */}
        <Form.Group as={Row} controlId="report_pay_per_task_format" className="mb-4">
          <Form.Label column sm="4">Format <span className="text-danger">*</span></Form.Label>
          <Col sm="8">
            <Form.Select name="format">
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Select>
          </Col>
        </Form.Group>

        {/* Submit Button */}
         <Form.Group as={Row}>
          <Col sm={{ span: 8, offset: 4 }}>
            <Link to="/AddInternalCaseReason">
              <Button
                id="pay-per-task-submit"
                type="button"
                variant="primary"
                className="w-100 mt-2"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                Run
              </Button>
            </Link>
          </Col>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default ReportForm;
